import React from 'react';
import CustomMarkdown from './CustomMarkdown/CustomMarkdown';
import styles from './assistantMessage.module.scss';
import { AiArtifact, Message, ResponseType } from '@/modules/chat/types/message';
import CustomIcon from '@/components/ui/CustomIcon';
import MessageOptions from './MessageOptions';
import { BaseButton } from '@/components/ui/BaseButton/BaseButton';

type Props = {
  message: Message;
  artifacts: AiArtifact;
  onOptionClick: (option: string, responseType: ResponseType) => void;
  isLatestMessage?: boolean;
  onArtifactClick?: (artifactId: string) => void;
  primaryColor?: string;
  secondaryColor?: string;
  aiMessageIcon?: string;
} & React.HTMLAttributes<HTMLDivElement>;

const AssistantMessage = ({
  artifacts,
  message,
  isLatestMessage = false,
  onOptionClick,
  onArtifactClick,
  primaryColor,
  secondaryColor,
  aiMessageIcon,
  ...props
}: Props): React.ReactElement => {
  const messageStyle = primaryColor ? { '--primary-color': primaryColor, '--secondary-color': secondaryColor } as React.CSSProperties : undefined;
  const processMessageContent = (content: string): string => {
    if (!content) {
      return '';
    }

    const artifactRegex = /(?:<)?artifact:([a-f0-9]{32})(?:>)?/g;

    if (!content.match(artifactRegex)) {
      return content;
    }

    return content.replace(artifactRegex, (match, artifactId) => {
      const artifactType = artifacts[artifactId]?.type;

      if (artifactType === 'report') {
        return `<ArtifactButton artifactId="${artifactId}" />`;
      }

      return ``;
    });
  };

  const ArtifactButton = ({ artifactId }: { artifactId: string }) => {
    const artifactType = artifacts[artifactId]?.type;

    if (artifactType !== 'report') {
      return null;
    }

    return (
      <BaseButton
        variant="primary"
        text="Ver Informe"
        onClick={() => onArtifactClick && onArtifactClick(artifactId)}
        className={styles['artifact-button']}
      />
    );
  };

  return (
    <div className={styles['assistant-message-container']}>
      <div className={styles['assistant-message']} style={messageStyle} {...props}>
        <CustomMarkdown
          content={processMessageContent(message.content)}
          overrides={{
            ArtifactButton: {
              component: ArtifactButton,
            },
          }}
        />

      </div>
      <MessageOptions options={message.options ?? []} onOptionClick={onOptionClick} />
      <div className={styles['message-metadata']}>
        480Bot • Asistente IA • Ahora
      </div>
    </div>
  );
};

export default AssistantMessage;
